import { Button } from '../Forms/Forms';
import { useEffect, useRef } from 'react';
import './ForfaitList.scss'
import { useState } from 'react';
import warningImg from '../../images/AP/ap-Alert-Outline.svg'
import PopIn from '../PopIn/PopIn';
import CONSTANTS from '../../Constants';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedForfaitsToStore, setSelectedMandatoryAdditionalForfaitsToStore } from '../../redux-files/actions/action';
import { isMobile } from '../../helpers/helpers';
import ForfaitRevisionItem from './ForfaitRevisionItem';
import ForfaitRegularItem from './ForfaitRegularItem';
import { pushEventToGTM } from '../../helpers/trackerManager';



const ForfaitList = ({ pasKilometrique, operationForfaits, revisionConstructorForfait, onSelectedForfait }) => {
    const selectedMandatoryForfaitsFromStore = useSelector(state => state.ndel_store.selectedMandatoryAdditionalForfaits)
    const selectedForfaitFromStore = useSelector(state => state.ndel_store.selectedForfaits)
    const selectedOperationsFromStore = useSelector(state => state.ndel_store.selectedOperations)

    const [selectedForfaits, setSelectedForfaits] = useState(selectedForfaitFromStore)
    const [selectedMandatoryOperations, setSelectedMandatoryOperations] = useState(selectedMandatoryForfaitsFromStore)
    const [showMandatoryOperationsPopIn, setShowMandatoryOperationsPopIn] = useState(false)
    const [openRevisionForfaitId, setOpenRevisionForfaitId] = useState('')
    const dispatch = useDispatch()

    const buttonRef = useRef(null);

    useEffect(() => {
        console.log('forfaitListe UseEffect ... ')
        if (selectedForfaitFromStore.length < 1) {
            setOpenRevisionForfaitId('')
        }
        selectedForfaitFromStore.forEach(item => {
            revisionConstructorForfait.forEach(forf => {
                if (item.Items[0].Ref === forf.Items[0].Ref) {

                    forf.isChecked = true
                    setOpenRevisionForfaitId(forf.Items[0].Ref)
                } else {
                    forf.isChecked = false
                }
            })

        })

    }, [revisionConstructorForfait])



    const handleCheckedForfait = (forfait) => {
        if (forfait.forfaitFamilyCode === "FCT0002") { // if it is an annual service forafait
            const filtredSelectedForfaits = selectedForfaits.filter(item => item.forfaitFamilyCode !== "FCT0002")// on supprime l'ancien annual foarfait selectionné 
            const selectedRevisionForfait = selectedForfaits.filter(item => item.forfaitFamilyCode === "FCT0002")// on supprime l'ancien annual foarfait selectionné 
            setOpenRevisionForfaitId(forfait.Items[0].Ref)
            setSelectedForfaits(selectedRevisionForfait)
            setSelectedMandatoryOperations([])
            revisionConstructorForfait.map(annualRevisionForfait => {
                if (annualRevisionForfait.Items[0].Ref === forfait.Items[0].Ref) {
                    forfait.isChecked = true
                    if (selectedRevisionForfait.length > 0 && annualRevisionForfait.Items[0].Ref !== selectedRevisionForfait[0].Items[0].Ref) {
                        annualRevisionForfait.Operations.forEach(oper => oper.isChecked = false)
                    }
                    setSelectedForfaits([...filtredSelectedForfaits, forfait])
                } else {
                    annualRevisionForfait.isChecked = false
                }
            })
        }

        else {
            if (forfait.isChecked) {
                setSelectedForfaits([...selectedForfaits, forfait])
            }
            else {
                setSelectedForfaits(selectedForfaits.filter(item => item.Items[0].Ref !== forfait.Items[0].Ref))
            }
        }
        if (buttonRef.current) {
            buttonRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    /**
  * for the revision constructore operation to close a forfait whene another is selected
  */
    const addSelectedForfait = () => {
        // let selectedMandatoryOperation = []
        if (openRevisionForfaitId) {
            let annualServiceForfait = selectedForfaits.filter(item => item.forfaitFamilyCode === "FCT0002")
            // selectedMandatoryOperation = annualServiceForfait[0].Operations.filter(mandatoryOperation => mandatoryOperation.isChecked)
            if (isMobile()) {
                dispatch(setSelectedForfaitsToStore(selectedForfaits))
                onSelectedForfait(selectedForfaits)
            } else {
                if (selectedMandatoryOperations.length > 0 || annualServiceForfait[0].Operations.length <= 0) {
                    dispatch(setSelectedForfaitsToStore(selectedForfaits))
                    dispatch(setSelectedMandatoryAdditionalForfaitsToStore(selectedMandatoryOperations))
                    onSelectedForfait(selectedForfaits, selectedMandatoryOperations)
                    pushEventToGTM({
                        pageName: 'services - révision',
                        eventAction: 'Select::Price::AdditionalOperation',
                        eventLabel: isMobile() ? CONSTANTS.LABELS.common_v2_continue : CONSTANTS.LABELS.dealer_locator_filter_apply,
                        eventCategory: 'Content'
                    })

                } else {
                    setShowMandatoryOperationsPopIn(true)
                    pushEventToGTM({
                        pageName: 'services - révision',
                        eventAction: 'Display::Popin::AdditionalOperation',
                        eventLabel: isMobile() ? CONSTANTS.LABELS.common_v2_continue : CONSTANTS.LABELS.dealer_locator_filter_apply,
                        eventCategory: 'Content'
                    })
                }
            }


        } else {
            dispatch(setSelectedForfaitsToStore(selectedForfaits))
            onSelectedForfait(selectedForfaits, selectedMandatoryOperations)
            pushEventToGTM({
                pageName: 'services',
                eventAction: 'Select::Price',
                eventLabel: isMobile() ? CONSTANTS.LABELS.common_v2_continue : CONSTANTS.LABELS.dealer_locator_filter_apply,
                eventCategory: 'Content'
            })
        }
    }

    const handleMandatoryOperations = (mandatoryOperation) => {
        if (mandatoryOperation.isChecked) {
            setSelectedMandatoryOperations([...selectedMandatoryOperations, mandatoryOperation])
        }
        else {
            setSelectedMandatoryOperations(selectedMandatoryOperations.filter(item => item.Items[0].Ref !== mandatoryOperation.Items[0].Ref))
        }
    }

    const isDisabled = () => {
        if (!isMobile()) {
            const openOperation = selectedOperationsFromStore.filter(oper => oper.isForfaitsBlockOpen)
            let checkedForfaits = selectedForfaits.filter(forf => openOperation[0].interventionForfaits.some(operForf => operForf.Code === forf.forfaitFamilyCode))
            return checkedForfaits.length < 1
        }
        else {
            if (!operationForfaits[0].isConstructeur) {
                return !operationForfaits.some(forf => forf.SubFunctionList[0].ForfaitList.some(forf => forf.isChecked))
            } else {
                console.log(revisionConstructorForfait)
                return !revisionConstructorForfait.some(revisForf => revisForf.isChecked)
            }

        }

    }

    const popInVehicleContent = <div className='popin-mandatory-operations'>
        <p className='label1'>{CONSTANTS.LABELS.needs_basket_maintenance_alert_label1}</p>
        <p className='label2'>{CONSTANTS.LABELS.needs_basket_maintenance_alert_label2}</p>
        <p className='label3'>{CONSTANTS.LABELS.needs_basket_maintenance_alert_label3}</p>
    </div>

    return (

        <div className='operation-detail-forfait-wrapper'>
            {
                !operationForfaits[0].isConstructeur ? operationForfaits.map((forfait, index) => {
                    return (
                        <div key={index} >
                            <div className="forfaits-title">{forfait.Title}</div>
                            {
                                forfait.SubFunctionList.map(subFunction => {
                                    return (subFunction.ForfaitList.map((item, index) => {
                                        return (
                                            <ForfaitRegularItem
                                                key={index}
                                                forfait={item}
                                                forfaitFamilyCode={subFunction.Code}
                                                addToCheckedForfaits={handleCheckedForfait}
                                            />
                                        )
                                    })
                                    )
                                })
                            }
                        </div>
                    )
                })
                    :
                    revisionConstructorForfait.length < 1
                        ? <p className='choose_km_label'>{CONSTANTS.LABELS.needs_quote_maintenance}</p>
                        :
                        revisionConstructorForfait.map((forfait, i) => {
                            return (
                                <ForfaitRevisionItem
                                    key={i}
                                    forfait={forfait}
                                    open={forfait.Items[0].Ref === openRevisionForfaitId}
                                    addToCheckedForfaits={handleCheckedForfait}
                                    handleMandatoryOperations={handleMandatoryOperations}
                                />
                            )
                        })
            }

            <Button ref={buttonRef} isDisabled={isDisabled()} handlClick={addSelectedForfait} >
                {isMobile() ? CONSTANTS.LABELS.common_v2_continue : CONSTANTS.LABELS.dealer_locator_filter_apply /*continue : Apply*/}
            </Button>

            {!isMobile() && showMandatoryOperationsPopIn && <PopIn
                title={CONSTANTS.LABELS.needs_basket_maintenance_alert_title}
                content={popInVehicleContent}
                titlePicto={
                    {
                        showTitlePicto: true,
                        src: warningImg,
                        alt: 'warning'
                    }
                }
                primaryButtonLabel={CONSTANTS.LABELS.needs_basket_maintenance_alert_choose}
                secondaryButtonLabel={CONSTANTS.LABELS.needs_basket_maintenance_alert_ignore}
                handlePrimaryButton={() => {
                    setShowMandatoryOperationsPopIn(false);
                    pushEventToGTM({
                        pageName: 'services - révision - popin additional Operation',
                        eventAction: 'Select::Popin::AdditionalOperation',
                        eventLabel: CONSTANTS.LABELS.needs_basket_maintenance_alert_choose,
                        eventCategory: 'Content'
                    })
                }
                }
                handleSecondaryButton={() => {
                    setShowMandatoryOperationsPopIn(false);
                    dispatch(setSelectedForfaitsToStore(selectedForfaits))
                    dispatch(setSelectedMandatoryAdditionalForfaitsToStore(selectedMandatoryOperations))
                    onSelectedForfait(selectedForfaits, selectedMandatoryOperations);
                    pushEventToGTM({
                        pageName: 'services - révision - popin additional Operation',
                        eventAction: 'Select::Popin::AdditionalOperation',
                        eventLabel: CONSTANTS.LABELS.needs_basket_maintenance_alert_ignore,
                        eventCategory: 'Content'
                    })
                }
                }
            />}
        </div>
    );
}
export default ForfaitList;